exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn-redirect[data-v-ac7b4b74]:hover{background:#f74a4b;color:#fff;border:none}button.btn-redirect:hover i[data-v-ac7b4b74]{color:#fff}button.btn-redirect i[data-v-ac7b4b74]{font-size:1em}button.v-btn:not(.v-btn--round).v-size--small[data-v-ac7b4b74]{width:35px!important;height:25px!important;min-width:35px!important}@media screen and (min-width:768px){button.v-btn:not(.v-btn--round).v-size--small[data-v-ac7b4b74]{height:35px!important;width:49px!important;min-width:49px!important}}", ""]);

// exports
